import { CheckOrganizationAccessFACCProps, CheckOrganizationAccessProps } from ".";
import { useCheckOrganizationAccess } from "../../../hooks/utils/useCheckOrganizationAccess";
import { RequiredPermissionsPopOver } from "../RequiredPermissionsPopOver";

export function CheckOrganizationAccess<
    F extends CheckOrganizationAccessFACCProps = CheckOrganizationAccessFACCProps
>({
    children,
    orgId,
    userId,
    any,
    roles,
    hideChildrenIfNoAccess = false,
    ...props
}: Readonly<CheckOrganizationAccessProps<F>>) {
    const { hasAccess, userPermissions } = useCheckOrganizationAccess({
        orgId,
        userId,
        requiredPermissions: props,
        any,
        roles
    });

    if (typeof children === 'function') {
        return children({ ...userPermissions as F, hasAccess })
    }
    if (!hasAccess && hideChildrenIfNoAccess) {
        return null;
    }
    if (hasAccess) {
        return <>{children}</>
    }
    return (
        <RequiredPermissionsPopOver requiredPermissions={Object.keys(props)} any={any} roles={roles}>
            {children}
        </RequiredPermissionsPopOver>
    )
} 